import { render, staticRenderFns } from "./ClinicalReports.vue?vue&type=template&id=dd61fb4e&scoped=true&"
import script from "./ClinicalReports.vue?vue&type=script&lang=js&"
export * from "./ClinicalReports.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalReports.vue?vue&type=style&index=0&id=dd61fb4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd61fb4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd61fb4e')) {
      api.createRecord('dd61fb4e', component.options)
    } else {
      api.reload('dd61fb4e', component.options)
    }
    module.hot.accept("./ClinicalReports.vue?vue&type=template&id=dd61fb4e&scoped=true&", function () {
      api.rerender('dd61fb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/Prescription/ClinicalReports.vue"
export default component.exports